import http from "./httpService";
import jwtDecode from "jwt-decode";

const apiUrl = http.getApiUrl();
const endPoint = "/auth/";
const url = apiUrl + endPoint;
const tokenKey = "smartciti-token";

http.setJwt(getJwt());

export async function getVerificationToken(tokenId) {
  return await http.get(url + `getVerificationToken/${tokenId}`);
}

export async function resetPassword(payload) {
  const { data: jwt } = await http.put(url + "resetPassword", payload);
  localStorage.setItem(tokenKey, jwt);
}

export async function verifyEmail(email) {
  return await http.post(url + "verifyEmail", email);
}

export async function login(credentials) {
  const { data: jwt } = await http.post(url, credentials);
  localStorage.setItem(tokenKey, jwt);
}

export function logout() {
  localStorage.removeItem(tokenKey);
}

export function getJwt() {
  return localStorage.getItem(tokenKey);
}

export function isSuperAdmin() {
  if (getCurrentUser().permission === "Super Admin") {
    return true;
  } else {
    return false;
  }
}

export function isAdmin() {
  if (getCurrentUser().category === "Admin") {
    return true;
  } else {
    return false;
  }
}

export function isCustomer() {
  if (
    getCurrentUser().category === "Individual" ||
    getCurrentUser().category === "Business"
  ) {
    return true;
  } else {
    return false;
  }
}

export function isEngineer() {
  if (getCurrentUser().permission === "Engineer") {
    return true;
  } else {
    return false;
  }
}

export function isAccounts() {
  if (getCurrentUser().permission === "Accounts") {
    return true;
  } else {
    return false;
  }
}

export function isSupport() {
  if (getCurrentUser().permission === "Support") {
    return true;
  } else {
    return false;
  }
}

export function getFLWPublicKey() {
  try {
    const jwt = localStorage.getItem(tokenKey);
    return jwtDecode(jwt).flutterwavePublicKey;
  } catch (ex) {
    return null;
  }
}

export function getPSPublicKey() {
  try {
    const jwt = localStorage.getItem(tokenKey);
    return jwtDecode(jwt).paystackPublicKey;
  } catch (ex) {
    return null;
  }
}

export function getFLWSubAccount1() {
  try {
    const jwt = localStorage.getItem(tokenKey);
    return jwtDecode(jwt).flutterwaveSubAccount1;
  } catch (ex) {
    return null;
  }
}

export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem(tokenKey);
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}
